import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { SITE_URL } from "@/lib/seo";

const sections = [
  { h: "1. Agreement", p: "By engaging LAK Atelier (\"we\", \"the atelier\") you agree to these Terms of Service. They form the contract between you (the client) and LAK Atelier." },
  { h: "2. Services", p: "We design, build, host and support bespoke websites. Your website is designed and built free of charge. A simple monthly retainer of £99 covers hosting, security, ongoing SEO, support and small refinements." },
  { h: "3. Term and cancellation", p: "Monthly support begins on the day your website launches and continues for a minimum initial term of six months. After this, either party may cancel with 30 days' written notice." },
  { h: "4. Client responsibilities", p: "The client agrees to provide brand assets, photography, copy direction and timely feedback so the project can be completed within the agreed timeline." },
  { h: "5. Intellectual property", p: "Once your website is live and your monthly retainer has commenced, the client owns the final design assets used on their website. LAK Atelier retains the right to display the finished work in a portfolio and case studies." },
  { h: "6. Hosting and uptime", p: "Hosting is provided through reputable third-party infrastructure. We aim for 99.9% monthly uptime but cannot warrant uninterrupted service." },
  { h: "7. Limitation of liability", p: "To the extent permitted by law, LAK Atelier's total liability under this agreement is limited to fees paid in the twelve months preceding any claim." },
  { h: "8. Governing law", p: "These terms are governed by the laws of England and Wales. Any dispute is subject to the exclusive jurisdiction of the courts of England and Wales." },
  { h: "9. Contact", p: "For any questions about these terms, please email info@lakatelier.com." },
];

export default function Terms() {
  const crumbs = [
    { name: "Home", url: `${SITE_URL}/` },
    { name: "Terms of Service", url: `${SITE_URL}/terms` },
  ];
  return (
    <main className="pt-32 sm:pt-40 bg-lak-bg">
      <Seo
        title="Terms of Service"
        description="The terms under which LAK Atelier provides bespoke web design, hosting and ongoing support services."
        breadcrumbs={crumbs}
      />
      <section className="lak-section pb-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-14">
          <Breadcrumbs items={crumbs} className="mb-10" />
          <Reveal><span className="eyebrow">Legal &middot; Terms</span></Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-8 font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight leading-[1.02]">
              Terms of Service
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 eyebrow text-lak-soft">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long" })}</p>
          </Reveal>
          <div className="mt-12 space-y-10 md:text-left">
            {sections.map((s) => (
              <Reveal key={s.h}>
                <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight">{s.h}</h2>
                <p className="mt-3 text-lak-soft leading-relaxed">{s.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
